'use client';
import React, { useRef, useCallback } from 'react';

/*
 * `toString` предотвращает попытку бандлера преобразовать вхождение к:
 * `import { useInsertionEffect } from 'react'`
 */ var useInsertionEffect = React["useInsertionEffect".toString()];
var useSafeInsertionEffect = useInsertionEffect || function(fn) {
    return fn();
};
function useEffectEvent(action) {
    var _ref_current;
    var ref = useRef(function() {
        throw new Error("Cannot call an event handler while rendering.");
    });
    useSafeInsertionEffect(function() {
        ref.current = action;
    });
    return useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return ref.current == null ? void 0 : (_ref_current = ref.current).call.apply(_ref_current, [].concat([
            ref
        ], args));
    }, []);
}

export { useEffectEvent };
